var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import "../styles/SliderCarousel.css";
import Slide from "./Slide";
var SliderCarousel = /** @class */ (function (_super) {
    __extends(SliderCarousel, _super);
    function SliderCarousel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderCarousel = function () {
            var images = _this.props.images;
            var slides = [];
            for (var i = 0; i < images.length; i++) {
                slides.push(_this.renderSlide(images[i], i));
            }
            return slides;
        };
        _this.renderSlide = function (url, index) {
            var _a = _this.props, width = _a.width, height = _a.height, slideStyle = _a.slideStyle;
            return (React.createElement(Slide, { key: "Slider-" + index, url: url, width: width + "px", height: height + "px", slideStyle: slideStyle }));
        };
        return _this;
    }
    SliderCarousel.prototype.render = function () {
        var _a = this.props, height = _a.height, width = _a.width, index = _a.index, offsetX = _a.offsetX;
        return (React.createElement("div", { style: {
                height: height,
                transform: "translateX(-" + (index * width - offsetX) + "px)",
                transition: offsetX !== 0 ? "none" : "transform 0.1s ease-in-out"
            }, className: "Slider-Carousel" }, this.renderCarousel()));
    };
    return SliderCarousel;
}(React.PureComponent));
export default SliderCarousel;
//# sourceMappingURL=SliderCarousel.js.map